import type { ComponentProps, ReactNode } from 'react'
import type { LoyaltyEligibleOffer } from 'loyalty/lib/esimOfferEligibility'
import useLoyaltyBenefitInclusions from 'loyalty/hooks/useLoyaltyBenefitInclusions'
import SearchTileRowInclusionItem from 'components/SearchKit/SearchTiles/shared/SearchTileRowInclusionItem'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import LoyaltyBenefitInfoIcon from 'loyalty/components/LoyaltyBenefitInfoIcon'

type InheritedOfferInclusionItemProps = Pick<ComponentProps<typeof OfferInclusionItem>, 'size'>

interface Props extends InheritedOfferInclusionItemProps {
  offer?: LoyaltyEligibleOffer
  variation?: App.Tours.TourV2OfferVariation
  variant?: 'search-tile' | 'offer-page'
  children?: (inclusions: Array<App.OfferInclusion>) => ReactNode
}

function LoyaltyInclusions({ offer, variation, variant, size, children }: Props) {
  const loyaltyInclusions = useLoyaltyBenefitInclusions(offer, variation)

  if (!loyaltyInclusions.length) {
    return null
  }

  if (children) {
    return <>{children(loyaltyInclusions)}</>
  }

  if (variant === 'search-tile') {
    return <>
      {loyaltyInclusions.map((inclusion) => <SearchTileRowInclusionItem
        key={inclusion.id}
        inclusion={inclusion}
        endIcon={<LoyaltyBenefitInfoIcon inclusionId={inclusion.id} />}
      />)}
    </>
  }

  if (variant === 'offer-page') {
    return <>
      {loyaltyInclusions.map((inclusion) => <OfferInclusionItem
        key={inclusion.id}
        inclusion={inclusion}
        size={size}
        endIcon={<LoyaltyBenefitInfoIcon inclusionId={inclusion.id} />}
      />)}
    </>
  }

  return null
}

export default LoyaltyInclusions
